// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    RegistryAddress,
    RegistryAddressFromJSON,
    RegistryAddressToJSON,
    RegistryBasic,
    RegistryBasicFromJSON,
    RegistryBasicToJSON,
    RegistryEndPoint,
    RegistryEndPointFromJSON,
    RegistryEndPointToJSON,
    RegistryIdentifier,
    RegistryIdentifierFromJSON,
    RegistryIdentifierToJSON,
    RegistryOtherName,
    RegistryOtherNameFromJSON,
    RegistryOtherNameToJSON,
    RegistryPracticeLocation,
    RegistryPracticeLocationFromJSON,
    RegistryPracticeLocationToJSON,
    RegistryTaxonomy,
    RegistryTaxonomyFromJSON,
    RegistryTaxonomyToJSON,
} from './';

/**
 * 
 * @export
 * @interface Registry
 */
export interface Registry {
    /**
     * 
     * OpenAPI data type: {RegistryBasic}
     * @type {RegistryBasic}
     * @memberof Registry
     */
    basic?: RegistryBasic;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof Registry
     */
    number?: string;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<RegistryAddress>}
     * @memberof Registry
     */
    addresses?: Array<RegistryAddress>;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<RegistryEndPoint>}
     * @memberof Registry
     */
    endPoints?: Array<RegistryEndPoint>;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<RegistryOtherName>}
     * @memberof Registry
     */
    otherNames?: Array<RegistryOtherName>;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<RegistryTaxonomy>}
     * @memberof Registry
     */
    taxonomies?: Array<RegistryTaxonomy>;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<RegistryIdentifier>}
     * @memberof Registry
     */
    identifiers?: Array<RegistryIdentifier>;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof Registry
     */
    enumerationType?: string;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<RegistryPracticeLocation>}
     * @memberof Registry
     */
    practiceLocations?: Array<RegistryPracticeLocation>;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof Registry
     */
    type?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof Registry
     */
    title?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof Registry
     */
    detail?: string;
    /**
     * 
     * OpenAPI data type: {integer}
     * @type {number}
     * @memberof Registry
     */
    status?: number;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof Registry
     */
    instance?: string;
}

export function RegistryFromJSON(json: any): Registry {
    return {
            'basic': !exists(json, 'basic') ? undefined : RegistryBasicFromJSON(json['basic']),
            'number': !exists(json, 'number') ? undefined : json['number'],
            'addresses': !exists(json, 'addresses') ? undefined : (json['addresses'] as Array<any>).map(RegistryAddressFromJSON),
            'endPoints': !exists(json, 'endPoints') ? undefined : (json['endPoints'] as Array<any>).map(RegistryEndPointFromJSON),
            'otherNames': !exists(json, 'otherNames') ? undefined : (json['otherNames'] as Array<any>).map(RegistryOtherNameFromJSON),
            'taxonomies': !exists(json, 'taxonomies') ? undefined : (json['taxonomies'] as Array<any>).map(RegistryTaxonomyFromJSON),
            'identifiers': !exists(json, 'identifiers') ? undefined : (json['identifiers'] as Array<any>).map(RegistryIdentifierFromJSON),
            'enumerationType': !exists(json, 'enumerationType') ? undefined : json['enumerationType'],
            'practiceLocations': !exists(json, 'practiceLocations') ? undefined : (json['practiceLocations'] as Array<any>).map(RegistryPracticeLocationFromJSON),
            'type': !exists(json, 'type') ? undefined : json['type'],
            'title': !exists(json, 'title') ? undefined : json['title'],
            'detail': !exists(json, 'detail') ? undefined : json['detail'],
            'status': !exists(json, 'status') ? undefined : json['status'],
            'instance': !exists(json, 'instance') ? undefined : json['instance'],
    };

}

export function RegistryToForm(value?: Registry): any {
    let jsonVal = RegistryToJSON(value);
    let retVal = '';
    if(jsonVal !== undefined && jsonVal != null) {
        Object.keys(jsonVal).forEach((v, i) => {
            if(i > 0) retVal+= "&";
            retVal+= encodeURIComponent(v) + "=" + encodeURIComponent(jsonVal[v]);
        });
    }
    return retVal;
}

function cleanupBlankValuesForBackend(val?:any): any {
    if(val instanceof Array) {
        return (val as Array<any>).filter((val) => { return val !== undefined && val !== null && val !== ''});
    } else {
        return (val === '') ? null : val;
    }
}

export function RegistryToJSON(value?: Registry): any {
    value = cleanupBlankValuesForBackend(value);
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
            'basic': RegistryBasicToJSON(value.basic),
            'number': cleanupBlankValuesForBackend(value.number),
            'addresses': (value.addresses === undefined || value.addresses === null) ? undefined : (value.addresses as Array<any>).map(RegistryAddressToJSON),
            'endPoints': (value.endPoints === undefined || value.endPoints === null) ? undefined : (value.endPoints as Array<any>).map(RegistryEndPointToJSON),
            'otherNames': (value.otherNames === undefined || value.otherNames === null) ? undefined : (value.otherNames as Array<any>).map(RegistryOtherNameToJSON),
            'taxonomies': (value.taxonomies === undefined || value.taxonomies === null) ? undefined : (value.taxonomies as Array<any>).map(RegistryTaxonomyToJSON),
            'identifiers': (value.identifiers === undefined || value.identifiers === null) ? undefined : (value.identifiers as Array<any>).map(RegistryIdentifierToJSON),
            'enumerationType': cleanupBlankValuesForBackend(value.enumerationType),
            'practiceLocations': (value.practiceLocations === undefined || value.practiceLocations === null) ? undefined : (value.practiceLocations as Array<any>).map(RegistryPracticeLocationToJSON),
            'type': cleanupBlankValuesForBackend(value.type),
            'title': cleanupBlankValuesForBackend(value.title),
            'detail': cleanupBlankValuesForBackend(value.detail),
            'status': cleanupBlankValuesForBackend(value.status),
            'instance': cleanupBlankValuesForBackend(value.instance),
    };
}


